// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topbar.navbar.sticky-top {
  width: 100%;
  min-height: 72px;
  padding-top: .5rem;
  padding-bottom: .5rem;
  z-index: 1030;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(14px) saturate(180%);
  -webkit-backdrop-filter: blur(14px) saturate(180%);
  border-bottom: 1px solid rgba(15, 31, 46, 0.06);
  transition: box-shadow .2s ease;
}

.topbar .navbar-brand {
  font-size: 1.05rem;
  letter-spacing: .2px;
}

.topbar .navbar-brand span.fw-bold {
  background: linear-gradient(135deg, var(--bs-primary), #6aa8ff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.topbar-live {
  width: 8px;
  height: 8px;
  background: var(--brand-live);
  border-radius: 50%;
  display: inline-block;
  animation: topbar-pulse 2s infinite;
}

@keyframes topbar-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(22, 199, 154, .5);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(22, 199, 154, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(22, 199, 154, 0);
  }
}

/* Bouton burger (mobile) */
.topbar .btn-link {
  color: #2d3748;
  border-radius: 10px;
  transition: background .15s ease;
}

.topbar .btn-link:hover {
  background: rgba(47, 111, 235, 0.08);
  color: var(--bs-primary);
}

/* Bouton profil */
.topbar .dropdown>.btn {
  background: rgba(15, 31, 46, 0.04);
  border: 1px solid rgba(15, 31, 46, 0.06) !important;
  padding: .35rem .9rem .35rem .35rem;
  transition: box-shadow .2s ease, transform .15s ease;
}

.topbar .dropdown>.btn:hover {
  box-shadow: 0 4px 14px rgba(15, 31, 46, 0.1);
  transform: translateY(-1px);
}

.topbar .fw-semibold {
  color: #2d3748;
}

.topbar-avatar {
  width: 34px;
  height: 34px;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px var(--bs-primary);
}

/* Dropdown menu */
.dropdown-menu {
  border: none;
  border-radius: 14px;
  padding: .5rem;
  box-shadow: 0 12px 32px rgba(15, 31, 46, 0.14);
  margin-top: .5rem !important;
}

.dropdown-item {
  padding: .65rem .9rem;
  border-radius: 9px;
  font-weight: 500;
  transition: background .15s ease;
}

.dropdown-item:hover {
  background: #eef4ff;
}

.dropdown-item.text-danger:hover {
  background: #ffe8e8;
}

.dropdown-divider {
  margin: .35rem 0;
  opacity: .08;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/topbar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,+CAA+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,+DAA+D;EAC/D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,mDAAmD;EACnD,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".topbar.navbar.sticky-top {\n  width: 100%;\n  min-height: 72px;\n  padding-top: .5rem;\n  padding-bottom: .5rem;\n  z-index: 1030;\n  background: rgba(255, 255, 255, 0.75);\n  backdrop-filter: blur(14px) saturate(180%);\n  -webkit-backdrop-filter: blur(14px) saturate(180%);\n  border-bottom: 1px solid rgba(15, 31, 46, 0.06);\n  transition: box-shadow .2s ease;\n}\n\n.topbar .navbar-brand {\n  font-size: 1.05rem;\n  letter-spacing: .2px;\n}\n\n.topbar .navbar-brand span.fw-bold {\n  background: linear-gradient(135deg, var(--bs-primary), #6aa8ff);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.topbar-live {\n  width: 8px;\n  height: 8px;\n  background: var(--brand-live);\n  border-radius: 50%;\n  display: inline-block;\n  animation: topbar-pulse 2s infinite;\n}\n\n@keyframes topbar-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(22, 199, 154, .5);\n  }\n\n  70% {\n    box-shadow: 0 0 0 6px rgba(22, 199, 154, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(22, 199, 154, 0);\n  }\n}\n\n/* Bouton burger (mobile) */\n.topbar .btn-link {\n  color: #2d3748;\n  border-radius: 10px;\n  transition: background .15s ease;\n}\n\n.topbar .btn-link:hover {\n  background: rgba(47, 111, 235, 0.08);\n  color: var(--bs-primary);\n}\n\n/* Bouton profil */\n.topbar .dropdown>.btn {\n  background: rgba(15, 31, 46, 0.04);\n  border: 1px solid rgba(15, 31, 46, 0.06) !important;\n  padding: .35rem .9rem .35rem .35rem;\n  transition: box-shadow .2s ease, transform .15s ease;\n}\n\n.topbar .dropdown>.btn:hover {\n  box-shadow: 0 4px 14px rgba(15, 31, 46, 0.1);\n  transform: translateY(-1px);\n}\n\n.topbar .fw-semibold {\n  color: #2d3748;\n}\n\n.topbar-avatar {\n  width: 34px;\n  height: 34px;\n  object-fit: cover;\n  border: 2px solid #fff;\n  box-shadow: 0 0 0 2px var(--bs-primary);\n}\n\n/* Dropdown menu */\n.dropdown-menu {\n  border: none;\n  border-radius: 14px;\n  padding: .5rem;\n  box-shadow: 0 12px 32px rgba(15, 31, 46, 0.14);\n  margin-top: .5rem !important;\n}\n\n.dropdown-item {\n  padding: .65rem .9rem;\n  border-radius: 9px;\n  font-weight: 500;\n  transition: background .15s ease;\n}\n\n.dropdown-item:hover {\n  background: #eef4ff;\n}\n\n.dropdown-item.text-danger:hover {\n  background: #ffe8e8;\n}\n\n.dropdown-divider {\n  margin: .35rem 0;\n  opacity: .08;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
